module.exports = __webpack_public_path__ + "img/xls.79cf664e.svg";